import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Profile from "../views/Profile.vue";
import Login from "../views/auth/Login.vue";
import store from "../store";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  }
  ,
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true, requiresAdmin: true },
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/settings",
    name: "KioskSettings",
    component: () => import("../views/Settings/Index.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },

  //Sections routes
  {
    path: "/testimonials",
    name: "Testimonials",
    component: () => import("../views/Testimonials/List.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/testimonials/create",
    name: "TestimonialCreate",
    component: () => import("../views/Testimonials/Create.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/testimonials/:id/edit",
    name: "TestimonialEdit",
    component: () => import("../views/Testimonials/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  //city routes
  {
    path: "/cities",
    name: "Cities",
    component: () => import("../views/Cities/List.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/cities/create",
    name: "CityCreate",
    component: () => import("../views/Cities/Create.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/cities/:id/edit",
    name: "CityEdit",
    component: () => import("../views/Cities/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  //blog routes
  {
    path: "/blogs",
    name: "Blogs",
    component: () => import("../views/Blogs/List.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/blogs/create",
    name: "BlogCreate",
    component: () => import("../views/Blogs/Create.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/blogs/:slug/edit",
    name: "BlogEdit",
    component: () => import("../views/Blogs/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true },
  },

  //contacts routes
  {
    path: "/contacts",
    name: "Contacts",
    component: () => import("@/views/Contacts/ContactList.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/contacts/:id/view",
    name: "ContactView",
    component: () => import("@/views/Contacts/ContactView.vue"),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  //home banners routes
  {
    path: "/home-banners",
    name: "Home Banners",
    component: () => import("../views/HomeBanners/List.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/home-banners/create",
    name: "HomeBannerCreate",
    component: () => import("../views/HomeBanners/Create.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/home-banners/:id/edit",
    name: "HomeBannerEdit",
    component: () => import("../views/HomeBanners/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  //country routes
  {
    path: "/countries",
    name: "Countries",
    component: () => import("../views/Countries/List.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/countries/create",
    name: "CountryCreate",
    component: () => import("../views/Countries/Create.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/countries/:id/edit",
    name: "CountryEdit",
    component: () => import("../views/Countries/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true }
  },


  //district routes
  {
    path: "/districts",
    name: "Districts",
    component: () => import("../views/Districts/List.vue"),
    meta: {
      requiresAuth: true, requiresAdmin: true
    }
  },
  {
    path: "/districts/create",
    name: "DistrictCreate",
    component: () => import("../views/Districts/Create.vue"),
    meta: {
      requiresAuth: true, requiresAdmin: true
    }
  },
  {
    path: "/districts/:id/edit",
    name: "DistrictEdit",
    component: () => import("../views/Districts/Edit.vue"),
    props: true,
    meta: {
      requiresAuth: true, requiresAdmin: true
    }
  },
  //categories routes
  {
    path: "/categories",
    name: "Categories",
    component: () => import("../views/Categories/List.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/categories/create",
    name: "CategoryCreate",
    component: () => import("../views/Categories/Create.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/categories/:id/edit",
    name: "CategoryEdit",
    component: () => import("../views/Categories/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  // SubCategory routes
  {
    path: "/sub-categories",
    name: "SubCategories",
    component: () => import("../views/SubCategories/List.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/sub-categories/create",
    name: "SubCategoryCreate",
    component: () => import("../views/SubCategories/Create.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/sub-categories/:id/edit",
    name: "SubCategoryEdit",
    component: () => import("../views/SubCategories/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  // Product routes
  {
    path: "/products",
    name: "Products",
    component: () => import("../views/Products/List.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/products/create",
    name: "ProductCreate",
    component: () => import("../views/Products/Create.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/products/:id/edit",
    name: "ProductEdit",
    component: () => import("../views/Products/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/products/:id/view",
    name: "ProductView",
    component: () => import("../views/Products/View.vue"),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/products/option-types",
    name: "OptionTypeManagement",
    component: () => import("../views/Products/OptionTypeManagement.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Manage Option Types' }
  },
  // Product Set Items routes
  {
    path: "/product-set-items",
    name: "ProductSetItems",
    component: () => import("../views/ProductSetItems/List.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/product-set-items/create",
    name: "ProductSetItemCreate",
    component: () => import("../views/ProductSetItems/Create.vue"),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/product-set-items/:id/edit",
    name: "ProductSetItemEdit",
    component: () => import("../views/ProductSetItems/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/product-set-items/:id/view",
    name: "ProductSetItemView",
    component: () => import("../views/ProductSetItems/View.vue"),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/orders",
    name: "OrdersList",
    component: () => import("@/views/Orders/List.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/orders/:id",
    name: "OrderView",
    component: () => import("@/views/Orders/View.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/orders/:id/edit",
    name: "OrderEdit",
    component: () => import("@/views/Orders/Edit.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },

  //sendEmail route
  {
    path: "/sendEmail",
    name: "SendEmail",
    component: () => import("../views/SendEmail/SendEmail.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },

  {
    path: "/subscribers",
    name: "Subscribers",
    component: () => import("../views/Subscribers/List.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },

  //users routes
];
const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  const loggedIn = store.getters["auth/isLoggedIn"];
  const isAdmin = store.getters["auth/isAdmin"];

  if (to.meta.requiresAuth && !loggedIn) {
    next("/login");
  } else if (to.meta.requiresAdmin && !isAdmin) {
    // If user is logged in but not an admin, redirect to login (or an unauthorized page)
    next("/login");
  } else {
    next();
  }
});

export default router;
